import swal from 'sweetalert2'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import {
  Button, SectionDivider, SidebarModal, Text,
} from '@domain-group/suit-theme'

import useUser from '@hooks/useUser'
import type { UseContactPayload } from '@hooks/useContact'

import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

type CreateUserParams = {
  createContactUser: (payload: HandleCallbackActionParams) => void,
  createFn: UseContactPayload['callbacks']['createContactUser'],
}

const confirmCreateUser = (params: CreateUserParams) => {
  const { createContactUser, createFn } = params

  const createUserPayload = {
    callbacks: {
      action: createFn,
      buildActionParams: () => [{ include_contact_user: true }],
    },
    toastText: 'User Created',
  }

  swal.fire({
    confirmButtonColor: '#589958',
    confirmButtonText: 'Yes, create user.',
    icon: 'success',
    reverseButtons: true,
    showCancelButton: true,
    text: 'This will allow the user to login and view the vendor dashboard.',
    title: 'Create User Account?',
  }).then(({ value }) => {
    if (value){
      // @ts-expect-error TS2345
      createContactUser(createUserPayload)
    }
  })
}

interface UserProps {
  callbacks: {
    createContactUser: (payload: HandleCallbackActionParams) => void,
  },
  contactPayload: UseContactPayload,
}

const User = (props: UserProps) => {
  const {
    callbacks: { createContactUser },
    contactPayload,
  } = props

  const {
    callbacks: { createContactUser: createFn },
    contact: { user_id },
  } = contactPayload

  const {
    image,
    user,
    user: { full_name, mobile_number },
  } = useUser({ id: user_id })

  return (
    <>
      <SectionDivider marginTop="large">Contact User</SectionDivider>
      {!user.id && (
        <>
          <Text color="bodyFontLightColor" fontSize="small" lineHeight="1.3" marginTop="medium">
            If you want a user to be able to see campaign details and comment,
            &nbsp;leave feedback or download documents, they&apos;ll be required to be set up as a user.
          </Text>

          <Button
            buttonStyle="secondaryEdit"
            icon={<FontAwesomeIcon icon={faPlus} />}
            // @ts-expect-error
            marginTop="medium"
            onClick={() => confirmCreateUser({ createContactUser, createFn })}
            size="medium"
          >
            Create User
          </Button>
        </>
      )}

      {user.id && (
        <SidebarModal.User
          boxProps={{ border: 'none', paddingY: 'medium' }}
          disableHover
          // @ts-expect-error TS2339
          imageUrl={image?.square_url}
          key={user.id}
          subtitle={mobile_number || 'No Mobile'}
          title={full_name || 'Deleted User'}
        />
      )}
    </>
  )
}

export default User
